export default "/_next/static/assets/DunbarTall-ExtraLight_6aadb59bcb8227062a5397c333bda60e.woff2";